<template>
    <div v-if="isShow(rule)">
        <dt>
            <span :data-vendor="acc.split('%$%')[1]" class="icon-vender" data-size="m"></span>
            {{ acc.split("%$%")[0] }}
            <button type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="expand"
                    v-on:click="clickErrorToggle(acc, $event, rule)">
            </button>
        </dt>
        <dd v-if="this.isExpand" class="table-overflow-y">
            <table class="tbl-failer-detail">
                <caption></caption>
                <tbody v-if="!this.isEvntLogMapList">
                <tr>
                    <th scope="row">{{ $t('COMPLIANCE.LABEL.FAILURE_INTRODUCED') }}<!--Failure introduced--></th>
                    <td>{{ convertUtcTimezoneToLocal(dtDiff) }}</td>
                </tr>
                <tr>
                    <th scope="row">{{ $t('COMPLIANCE.LABEL.MESSAGE') }}<!--Message--></th>
                    <td v-html="getRsltMsg(rule, acc)"></td>
                </tr>
                <tr v-if="this.rgnYn === 'Y' && this.rgnLists.length > 0">
                    <th scope="row">{{ $t('LABEL.REGION') }}<!--Region--></th>
                    <td v-text="getRgnWithNewLine(rgnLists)">{{ getRgnWithNewLine(rgnLists) }}</td>
                </tr>
                </tbody>
                <tbody v-if="this.isEvntLogMapList" class="msg-template">
                <template v-for="(inst, index) of instInfoList">
                    <tr :key="`fi_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.FAILURE_INTRODUCED') }}<!--Failure introduced--></th>
                        <td>{{ convertUtcTimezoneToLocal(dtDiff) }}</td>
                    </tr>
                    <tr :key="`msg_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.MESSAGE') }}<!--Message--></th>
                        <td v-html="makeHtml(inst.errMessage)"></td>
                    </tr>
                    <tr v-for="(instByRgn, rgnIndex) of inst.instInfoListByRgn" :key="rgnIndex">
                        <td colspan="2">
                            <table class="fail-rule-table">
                                <tr class="fail-rule-row" v-if="!isUndefined(rgnIndex)">
                                    <th scope="row">{{ $t('LABEL.REGION') }}</th>
                                    <td>
                                        <span v-for="(rgn, index) in getRgnWithNewLine(rgnIndex)" :key="`rgn_${index}`">
                                            <!-- <a :href="getDeepLink(rule.ruleRvsnId)" class="deep-link" target="_blank"> {{ getRgnTxt(rgn) }} </a> -->
                                            {{ getRgnTxt(rgn) }}
                                        </span>
                                    </td>
                                </tr>
                                <tr class="fail-rule-row" v-if="!isUndefined(instByRgn.map(t=>t.instId))">
                                    <th scope="row">{{ $t('COMPLIANCE.LABEL.RESOURCE') }}</th>
                                    <td>
                                        <span v-for="(inst, index) in instByRgn" :key="`rsrc_${index}`">
                                            <a v-if="getDeepLink(rule, inst)!=null" :href="getDeepLink(rule, inst)" class="deep-link" target="_blank"> {{ inst.instId }} </a>
                                            <template v-else > {{ inst.instId }}</template>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr v-if="!isUndefined(inst.instNm)" :key="`in_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.INSTANCE_NAME') }}<!--instance name--></th>
                        <td>{{ inst.instNm }}</td>
                    </tr>
                    <tr v-if="!isUndefined(inst.instType)" :key="`it_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.INSTANCE_TYPE') }}<!--instance type--></th>
                        <td>{{ inst.instType }}</td>
                    </tr>
                    <tr v-if="!isUndefined(inst.os)" :key="`osn_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.OS_NAME') }}<!--os name--></th>
                        <td>{{ inst.os }}</td>
                    </tr>
                    <tr v-if="!isUndefined(inst.prodNm)" :key="`prdn_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.PRODUCTION_NAME') }}<!--product name--></th>
                        <td>{{ inst.prodNm }}</td>
                    </tr>
                    <tr v-if="!isUndefined(inst.secrGrp)" :key="`secg_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.SECURITY_GROUP') }}<!--security group--></th>
                        <td>{{ inst.secrGrp }}</td>
                    </tr>
                    <tr v-if="!isUndefined(inst.svcGrp)" :key="`serg_${index}`">
                        <th scope="row">{{ $t('COMPLIANCE.LABEL.SERVICE_GROUP') }}<!--service group--></th>
                        <td>
                            {{ inst.svcGrp }}
                            <template v-if="!isUndefined(inst.svcGrpNm)">
                                ( {{ inst.svcGrpNm }} )
                            </template>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </dd>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "complianceSideRuleDetailTable",
    props: ['rule', 'acc', 'ruleDetails', 'commonInfo', 'failedRulesList'],
    data: function () {
        return {
            selTab: null,
            ruleMsg: new Map(),
            isExpand: false,
            hasData: false,
            rgnYn: 'N',
            dtDiff: '',
            rgnLists: [],
            isEvntLogMapList: false,
            instInfoList: []
        }
    },
    methods: {
        getDeepLink(curRule, inst) {

            let link = null;
            try {
                    if (!this.Common.isEmptyText(this.ruleDetails.evntLog)) {
                        const evntLog = JSON.parse(this.ruleDetails.evntLog)[0];
                        link = _.find(this.$store.state.templateList, t=>t.tmpltId == evntLog.cmplRsltInfo[0].tmplId ).deepLink;
                            const accId = this.acc.substring(0, this.acc.indexOf('('));
                            if(link !=null){
                                link = link.replaceAll("{projectId}", accId);
                                let rgn = inst==null?"":inst.detailRgn||inst.rgn;
                                link = link.replaceAll("{rgnId}",rgn);
                                link = link.replaceAll("{instId}", inst.instId||undefined);
                                link = link.replaceAll("{accId}", accId);
                                link = link.replaceAll("{dataSet}", inst.dataSet||undefined);
                            }
                    }
            } catch (e) {
                console.error("getDeepLink: " + e);
            }
             if(link == null) return null;
            if(link.indexOf('}') > 0 ) return null;
            if(link.indexOf('{') > 0 ) return null;
            return link;
        },
        getRgnTxt(rgn) {
            if (this.$te('COMMON.REGION.' + rgn)) {
                return this.$t('COMMON.REGION.' + rgn);
            }
            return rgn;
        },
        isUndefined(key) {
            return (!key || key.includes('undefined') || !key[0]);
        },
        clickErrorToggle(acc, $event, rule) {
            $($event.target).toggleAttr('data-expand', '');
            $($event.target).closest('dt').toggleAttr('data-expand', '');
            this.assumbleErrLog(acc, rule, false)
        },
        assumbleErrLog(acc, rule, isInit) {
            if (this.isExpand === false || isInit) {
                if (!this.hasData) {
                    const eventLog = _.get(this.ruleDetails, 'evntLog');
                    if (this.Common.isJSON(eventLog)) {
                        const eventLogArray = JSON.parse(eventLog);

                        this.isEvntLogMapList = true;
                        this.dtDiff = this.ruleDetails.dtDiff;

                        //get first string from array
                        let accId = acc.split("(")[0];

                        //test
                        let errorList = [];
                        const vendor = acc.split("%$%")[1];
                        _.forEach(eventLogArray, (log) => {
                            if (log.accId === accId) {
                                const cmplRsltInfo = _.get(log, 'cmplRsltInfo');
                                if (cmplRsltInfo) {
                                    const messageLog = this.createErrMessageLog(cmplRsltInfo);
                                    if (vendor === "aws" && cmplRsltInfo) {
                                        let instInfoList = [];
                                        cmplRsltInfo.forEach((item)=>{
                                            instInfoList = instInfoList.concat(item.instInfoList);
                                        });
                                        messageLog.instInfoListByRgn = this.getInstInfoListByRgn(instInfoList);
                                    } else {
                                        messageLog.instInfoListByRgn = this.getInstInfoListByRgn(cmplRsltInfo[0].instInfoList);
                                    }
                                    errorList.push(messageLog)
                                }
                            }
                        });

                        this.instInfoList = errorList;

                        this.isExpand = true;
                        this.hasData = true;
                    }
                } else {
                    if (this.Common.isJSON(this.ruleDetails.evntLog)) {
                        this.isExpand = true;
                    } else {
                        this.isExpand = this.hasRslMsg(rule, acc);
                    }
                }
            } else {
                this.isExpand = false;
            }
        },
        getInstInfoListByRgn(instances) {
            let instGrup = _.groupBy(instances,'rgn');
            return instGrup;
        },
        createErrMessageLog(complianceResultInfo) {
            //eventLogList is JSON format
            let errMessage = '';
            let log = this.combineRuleErrMsg(complianceResultInfo)

            const compliance = _.head(complianceResultInfo);
            if (compliance) {
                errMessage = this.getErrRuleMsg(compliance);
            }
            log.errMessage = errMessage;
            return log;
        },
        combineRuleErrMsg(msgList) {
            let ruleDetail = {};
            let secrGrp = [];
            let instNm = [];
            let instType = [];
            let os = [];
            let prodNm = [];
            let svcGrp = [];
            let svcGrpNm = [];
            _.forEach(msgList, (compliance) => {
                const instanceInfoList = compliance.instInfoList;
                const messageDetail = this.getMessageDetail(instanceInfoList);
                secrGrp = _.union(secrGrp, messageDetail.secrGrp);
                instNm = _.union(instNm, messageDetail.instNm);
                instType = _.union(instType, messageDetail.instType);
                os = _.union(os, messageDetail.os);
                prodNm = _.union(prodNm, messageDetail.prodNm);
                svcGrp = _.union(svcGrp, messageDetail.svcGrp);
                svcGrpNm = _.union(svcGrpNm, messageDetail.svcGrpNm);
            });

            instNm = _.toString(instNm);
            instType = _.toString(instType);
            os = _.toString(os);
            prodNm = _.toString(prodNm);
            secrGrp = _.toString(secrGrp);
            svcGrp = _.toString(secrGrp);
            svcGrpNm = _.toString(svcGrpNm);
            ruleDetail = {secrGrp, instNm, instType, os, prodNm, svcGrp, svcGrpNm};
            return ruleDetail;
        },
        getMessageDetail(instanceInfoList) {
            let info = {};
            let rgn = [];
            let secrGrp = [];
            let instId = [];
            let instNm = [];
            let instType = [];
            let os = [];
            let prodNm = [];
            let svcGrp = [];
            let svcGrpNm = [];

            _.forEach(instanceInfoList, (instance) => {
                rgn.push(instance.rgn);
                secrGrp.push(instance.secrGrp);
                if (instance.instId) {
                    instId.push(instance.instId);
                }
                instNm.push(instance.instNm);
                instType.push(instance.instType);
                os.push(instance.os);
                prodNm.push(instance.prodNm);
                svcGrp.push(instance.svcGrp);
                svcGrpNm.push(instance.svcGrp);
            });
            rgn = _.sortedUniq(rgn);
            secrGrp = _.sortedUniq(secrGrp);
            instId = _.sortedUniq(instId);
            instNm = _.sortedUniq(instNm);
            instType = _.sortedUniq(instType);
            os = _.sortedUniq(os);
            prodNm = _.sortedUniq(prodNm);
            svcGrp = _.sortedUniq(svcGrp);
            svcGrpNm = _.sortedUniq(svcGrpNm);
            info = {rgn, instId, secrGrp, instNm, instType, os, prodNm, svcGrp, svcGrpNm};
            return info;
        },
        getErrRuleMsg: function (cmplInfo) {
            let returnValList = [];
            if (_.isArray(cmplInfo.evntLogM)) {
                for (let cmpl of cmplInfo.evntLogM) {
                    let logVal = cmpl.val;
                    if (this.Common.isJSON(logVal)) {
                        logVal = JSON.parse(logVal)
                    }
                    this.findLangPack(cmpl.code, logVal, returnValList)
                }
            } else {
                let logVal = cmplInfo.evntLogM.val;
                if (this.Common.isJSON(logVal)) {
                    logVal = JSON.parse(logVal)
                }
                returnValList = this.findLangPack(cmplInfo.evntLogM.code, logVal, returnValList)
            }
            return returnValList;
        },
        hasRslMsg: function (rule, acc) {
            return this.ruleMsg.has(acc + ":" + rule.ruleRvsnId);
        },
        getRgnWithNewLine: function (rgnLists) {
            let resultArray = _.toString(rgnLists);
            return _.split(resultArray, ',');
        },
        getRsltMsg: function (rule, acc) {
            let jsonVal = this.ruleMsg.get(acc + ":" + rule.ruleRvsnId);
            let returnValList = [];
            if (jsonVal) {
                for (let val of jsonVal) {
                    if (this.Common.isJSON(val)) {
                        let jsonItem = JSON.parse(val);
                        let keySet = Object.keys(jsonItem);
                        for (let key of keySet) {
                            returnValList = this.findLangPack(key, jsonItem[key], returnValList);
                        }
                    } else {
                        returnValList = this.findLangPack(val, null, returnValList);
                    }

                }
            }
            return this.makeHtml(returnValList);
        },
        makeHtml: function (returnValList) {
            let returnVal = '';
            _.forEach(returnValList, function (val) {
                returnVal = returnVal.concat(val, ' <br/> ');
            });
            return returnVal;
        },
        setLanguage: function (returnValList, langPack) {
            if (!_.includes(returnValList, langPack) && langPack !== '') {
                returnValList.push(langPack);
            }
        },
        findLangPack: function (key, valMap, returnValList) {
            let langPack = '';
            if (key.split('%$%') !== undefined && key.split('%$%').length > 1) {
                let keyList = key.split('%$%');
                for (let item of keyList) {
                    if (this.Common.isJSON(item)) {
                        let jsonItem = JSON.parse(item);
                        let keySet = Object.keys(jsonItem);
                        for (let newKey of keySet) {
                            returnValList = this.findLangPack(newKey, jsonItem[newKey], returnValList);
                        }
                    } else {
                        langPack = this.accumulateLangPack(item, valMap);
                        this.setLanguage(returnValList, langPack);
                    }
                }
            } else {
                langPack = this.accumulateLangPack(key, valMap);
                this.setLanguage(returnValList, langPack);
            }
            return returnValList;
        },
        accumulateLangPack: function (key, valMap) {
            let langPack = '';
            let isFind = false;
            for (let code of this.commonInfo.mulLangList) {
                if (code.evntCd === key) {
                    //console.log(code.ko, this.$i18n.locale, code[this.$i18n.locale]) //TODO language pack 적용 예정
                    if (valMap !== null) {
                        langPack = this.makeLangPack(code[this.$i18n.locale] != null ? code[this.$i18n.locale] : code.ko, valMap);
                    } else {
                        langPack = code[this.$i18n.locale] != null ? code[this.$i18n.locale] : code.ko;
                    }
                    isFind = true;
                }
            }
            if (!isFind) {
                langPack = key;
            }
            return langPack;
        },
        findBasicForm: function (tmpltId, source) {
            let newSource = [];
            let b = false;
            _.forEach(this.$store.state.templateList, function (item) {
                if (tmpltId === item.tmpltId) {
                    _.forEach(source, function (id) {
                        if (item.basicFormation.cnd.svcGrp) {
                            _.forEach(item.basicFormation.cnd.svcGrp.unit, function (svc) {
                                if (svc.key === id) {
                                    //console.log(svc.key, svc.val)
                                    newSource.push(svc.val);
                                    b = true;
                                }
                            })
                        }
                        if (item.basicFormation.cnd.view && item.basicFormation.cnd.view.unit) {
                            _.forEach(item.basicFormation.cnd.view.unit, function (svc) {
                                if (svc.key === id) {
                                    //console.log(svc.key, svc.val)
                                    newSource.push(svc.val);
                                    b = true;
                                }
                            })
                        }
                        if (!b) {
                            newSource.push(id);
                        }
                    })
                }
            })
            return newSource
        },
        makeLangPack: function (lang, valMap) {
            let returnLang = lang
            for (let key of Object.keys(valMap)) {
                let target = '#{' + key + '}#';
                let source = _.includes(['thisWeek', 'thisMonth', 'thisYear', 'hour', 'day', 'week', 'month', 'year'], valMap[key]) ? this.$t('BASIC_FORMATION_UNIT.' + valMap[key]) : valMap[key];
                if (typeof source === 'object') {
                    returnLang = returnLang.replace(target, this.findBasicForm(this.rule.cndVal[0].tmpltId, source));
                } else {
                    returnLang = returnLang.replace(target, source);
                }
            }
            return returnLang;
        },
        setLogs: function (logList) {
            let logs = '';
            if (logList.length > 1) {
                let cnt = 0;
                for (let log of logList) {
                    if (cnt > 0) {
                        logs = logs.concat(log, '%$%');
                    }
                    cnt++;
                }
                //logs = logs.concat(' <br/> ');
            } else {
                logs = logList[1] != null ? logList[1] : '';
            }
            return logs
        },
        convertUtcTimezoneToLocal: function (date) {
            return date == null ? '-' : this.Common.formattedDate(date)
        },
        isShow: function (rule) {
            //rule.ruleCmplRslt =='E' || rule.ruleCmplRslt=='F'
            return (rule.ruleCmplRslt === 'E' || rule.ruleCmplRslt === 'F')
        }
    }
}
</script>
<style scoped>
.list-compliance-failer {
    max-height: 100% !important;
}
tr.fail-rule-row {
    border-bottom: 1px solid rgba(255,45,71,0.2);
}
table.fail-rule-table {
    width: 95%;
    margin-left: 1%;
}
.list-compliance-failer dt[data-expand]+dd {
    max-height: 100%;
}
.tbl-failer-detail td span {
    background-color: #e6d8dba1;
    padding: 3px 8px 8px;
    margin: 5px;
    line-height: 30px;
    border-radius: 5px;
}

.tbl-failer-detail td span a.deep-link {
    color: rgb(255, 45, 71);
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/complianceSideRuleDetailTable.vue